import { RadioCheckedIcon, RadioUncheckedIcon } from "common/assets/icons";
import React from "react";

interface Props {
  finished: boolean;
  title: string;
}

export const ProgressionCheckmark: React.FC<React.PropsWithChildren<Props>> = ({
  finished,
  title,
}) => {
  return finished ? (
    <RadioCheckedIcon altText={`Du har fullført ${title}`} />
  ) : (
    <RadioUncheckedIcon altText={`Du har ikke fullført ${title}`} />
  );
};
